import { render, staticRenderFns } from "./CittadinoMain.vue?vue&type=template&id=64c47830&"
import script from "./CittadinoMain.vue?vue&type=script&lang=js&"
export * from "./CittadinoMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports